import { useLingui } from '@lingui/react/macro';
import { LoseRuleProps } from 'modules/championship/ui/components/form-parts/rules/types';
import React, { ReactNode } from 'react';
import { UDFormLabeledInput } from 'ud-form/components';
import { UDSectionTitle } from 'ud-ui/components';

interface ExtendedLoseRuleProps extends LoseRuleProps {
  children?: ReactNode;
}

const LoseBase: React.FC<ExtendedLoseRuleProps> = ({ sportType = 'general', children }) => {
  const { t } = useLingui();

  return (
    <>
      <UDSectionTitle
        title={t`Поражение`}
        icon="❌"
        tooltip={t`Настройка очков за поражение (обычно 0, но может меняться в особых форматах турниров).`}
      />

      <UDFormLabeledInput
        name="settings.lossScore"
        placeholder={t`0 очков`}
        label=""
        containerClassName="mb-4"
        inputContainerClassName="min-w-[120px]"
        alignRight={false}
        tooltip={t`Очки за проигрыш в основное время (обычно 0).`}
        tooltipProps={{ position: 'input-right' }}
      />

      <UDFormLabeledInput
        name="settings.lossScoreExtraTime"
        placeholder={t`0 очков`}
        label={t`В дополнительное время`}
        tooltip={t`Очки за проигрыш в дополнительное время.`}
        tooltipProps={{ position: 'input-right' }}
      />

      {/* Место для дополнительных полей */}
      {children}
    </>
  );
};

export default LoseBase;
